<section class="secondary-drawer-container">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
    <h5 class="drawer-title">Image Viewer</h5>
    <h3 class="font-12 text-start font-poppins mt-0 mb-3">You can double click on the main image to zoom in</h3>
</section>
<div class="custom-scroller">
    <div class="swiper-image-gallery">
        <swiper class="main-image" [slidesPerView]="1" [initialSlide]="initialSlide" [spaceBetween]="50"
            [thumbs]="{ swiper: thumbsSwiper }" [navigation]="{}" [zoom]="true">
            <ng-template class="main-image-wrapper" swiperSlide *ngFor="let image of imageList">
                <div class="image">
                    <div class="swiper-zoom-container">
                        <div class="invoice-img-tag" *ngIf="showBeforeAfterTag == true">
                            <span *ngIf="image.isAfter">After</span>
                            <span *ngIf="!image.isAfter">Before</span>
                        </div>
                        <img src="{{image.fileUrl}}" style="width: 100%">
                    </div>
                </div>
                <!-- <div class="comment text-start" *ngIf="image.comment">
                    <h3 class="font-12 font-semibold text-start font-poppins mt-0 mb-0 py-0 px-4">Comments</h3>

                    <div class="font-12 font-regular text-start font-poppins py-2 px-4" [innerHTML]="image.comment">
                    </div>
                </div> -->
                <div class="comment-accordion text-start" *ngIf="image.comment">
                    <mat-accordion>
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" 
                                             class="comments mat-elevation-z0">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <h3 class="font-12 font-semibold text-start font-poppins mt-0 mb-0 py-0 px-4">
                                        Comments
                                    </h3>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="custom-scroller comment-scroller">
                                <div class="font-12 font-regular text-start font-poppins pt-3 pb-0 px-4" 
                                     [innerHTML]="sanitizedComment">
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>                
            </ng-template>
        </swiper>
        <swiper class="thumbnails" *ngIf="imageList.length > 1" [slidesPerView]="5" [spaceBetween]="10"
            (swiper)="setThumbsSwiper($event)" [navigation]="{}" [scrollbar]="{ draggable: true }"
            [watchSlidesProgress]="true" [initialSlide]="initialSlide">
            <ng-template swiperSlide *ngFor="let thumb of imageList">
                <div class="invoice-img-tag" *ngIf="showBeforeAfterTag == true">
                    <span *ngIf="thumb.isAfter">After</span>
                    <span *ngIf="!thumb.isAfter">Before</span>
                </div>
                <img src="{{thumb.fileUrl}}">
            </ng-template>
        </swiper>
    </div>
</div>
